import React from 'react'
import { Link } from 'react-router-dom'

const SignalButton = ({link}) => {
  return (
    <button className='flex center size-12 relative'>
      <div className='absolute bg-red-500 animate-pulse inset-2 group-hover:inset-0 group-hover:opacity-50= quick rounded-full' />
      <Link target='_blank' to={link} className='relative group-hover:bg-gray-500/5 quick nowrap button space-x-2 w-fit px-2 py-2 rounded-full '>
        <i className='inline-flex center size-10 border1 border rounded-full rotate-45 hover:scale-[120%] quicker animate-pulse ri-arrow-up-line' />
      </Link>
    </button>
  )
}

export default SignalButton